import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotesBookmarkComponent } from './notes-bookmark/notes-bookmark.component';


const routes: Routes = [
  { path: '', component: NotesBookmarkComponent  },
  // { path: 'notes', component: NotesBookmarkComponent  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotesBookmarkRoutingModule { }
